// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  country_id: yup.string().label("COUNTRY").required(),
  province_id: yup.string().label("PROVINCE").required(),
  regency_id: yup.string().label("REGENCY").required(),
  subdistrict_id: yup.string().label("SUBDISTRICT").required(),
  village_id: yup.string().label("VILLAGE").required()
})